import { Card } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import type { StudentReward } from '@monorepo/shared/src/graph/schema-generated-types-student';

type StickerProps = {
  studentReward?: StudentReward;
};

const Sticker: React.FC<StickerProps> = ({ studentReward }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card} elevation={0}>
      {studentReward && (
        <img
          src={studentReward?.reward?.asset.src}
          className={classes.image}
          alt={studentReward?.reward?.asset?.description ?? ''}
        />
      )}
    </Card>
  );
};

const useStyles = makeStyles((theme) => ({
  card: {
    width: remCalc(264),
    height: remCalc(264),
    borderRadius: 20,
    border: `1px solid ${theme.palette.grey[400]}`,
  },
  image: {
    width: '100%',
    height: '100%',
  },
}));

export default Sticker;
